"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectDownshift = exports.defaultSelectFilter = void 0;
var downshift_1 = __importDefault(require("downshift"));
var match_sorter_1 = __importDefault(require("match-sorter"));
var react_1 = __importStar(require("react"));
/**
 * Default filter prop used by the Select component.
 */
function defaultSelectFilter(items, filter, itemToString) {
    return match_sorter_1.default(items, filter, { keys: [itemToString] });
}
exports.defaultSelectFilter = defaultSelectFilter;
/**
 * Downshift extension with item and filter management.
 */
function SelectDownshift(props) {
    var items = props.items, onFilterChange = props.onFilterChange, children = props.children, createNewItem = props.createNewItem, openOnFocus = props.openOnFocus, keepFilterAfterSelect = props.keepFilterAfterSelect, rest = __rest(props, ["items", "onFilterChange", "children", "createNewItem", "openOnFocus", "keepFilterAfterSelect"]);
    var stateReducer = react_1.useMemo(function () { return createReducer(props); }, [props]);
    var _a = react_1.useState(items), visibleItems = _a[0], setVisibleItems = _a[1];
    react_1.useEffect(function () {
        setVisibleItems(props.items);
    }, [props.items]);
    var handleStateChange = function (changes, downshift) {
        if (createNewItem &&
            changes.hasOwnProperty('inputValue') &&
            changes.type === downshift_1.default.stateChangeTypes.changeInput) {
            rest.onChange && rest.onChange(createNewItem(changes.inputValue), getStateAndHelpers(downshift));
        }
        if (changes.type === downshift_1.default.stateChangeTypes.changeInput && changes.inputValue === '') {
            rest.onChange && rest.onChange(null, getStateAndHelpers(downshift));
        }
        if (changes.isOpen) {
            onFilterChange(null, getStateAndHelpers(downshift));
        }
        if (changes.type === downshift_1.default.stateChangeTypes.changeInput) {
            onFilterChange(changes.inputValue, getStateAndHelpers(downshift));
        }
        if (!keepFilterAfterSelect &&
            (changes.type === downshift_1.default.stateChangeTypes.clickItem ||
                changes.type === downshift_1.default.stateChangeTypes.keyDownEnter)) {
            onFilterChange(null, getStateAndHelpers(downshift));
        }
        props.onStateChange && props.onStateChange(changes, getStateAndHelpers(downshift));
    };
    var handleChange = function (item, downshift) {
        props.onChange && props.onChange(item, getStateAndHelpers(downshift));
    };
    var createGetInputProps = function (getInputProps) { return function (options) {
        var _a = getInputProps(options), autoComplete = _a.autoComplete, rest = __rest(_a, ["autoComplete"]);
        return rest;
    }; };
    var getStateAndHelpers = function (downshift) { return (__assign(__assign({}, downshift), { items: items, visibleItems: visibleItems, setVisibleItems: setVisibleItems, getInputProps: createGetInputProps(downshift.getInputProps) })); };
    return (react_1.default.createElement(downshift_1.default, __assign({}, rest, { stateReducer: stateReducer, onStateChange: handleStateChange, onChange: handleChange }), function (downshift) { return children(getStateAndHelpers(downshift)); }));
}
exports.SelectDownshift = SelectDownshift;
SelectDownshift.defaultProps = {
    onFilterChange: function (filter, downshift) {
        var setVisibleItems = downshift.setVisibleItems, items = downshift.items, itemToString = downshift.itemToString;
        setVisibleItems(defaultSelectFilter(items, filter, itemToString));
    },
};
function createReducer(props) {
    var _a = props.openOnFocus, openOnFocus = _a === void 0 ? props.createNewItem ? false : undefined : _a, stateReducer = props.stateReducer;
    return function (state, changes) {
        if (openOnFocus === false && changes.type === undefined && !state.isOpen && changes.isOpen) {
            return __assign(__assign({}, changes), { isOpen: false });
        }
        return stateReducer ? stateReducer(state, changes) : changes;
    };
}
//# sourceMappingURL=SelectDownshift.js.map